import { render, staticRenderFns } from "./clonacion.vue?vue&type=template&id=562143b0"
import script from "./clonacion.vue?vue&type=script&lang=js"
export * from "./clonacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports